export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  coverImage: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
  featured: boolean;
}

export const articles: Article[] = [
  {
    slug: 'jm-comic-register-guide',
    title: 'JM Comic 注册教程：三步完成账号创建与实名认证',
    excerpt: '详细讲解JM Comic的完整注册流程，包括手机号验证、实名认证设置及账号安全配置，帮助新用户快速完成注册并开始阅读。',
    content: `<h2>第一步：访问JM Comic官方网站</h2>
<p>打开浏览器，在地址栏输入JM Comic官方网址。建议使用Chrome、Edge或Safari等主流浏览器以获得最佳体验。首次访问时，页面会自动跳转至首页，您可以在右上角找到"注册"按钮。</p>
<p><strong>注意事项：</strong>请务必通过官方渠道访问，避免使用第三方链接或非官方客户端，以保护您的账号安全和个人隐私。</p>

<h2>第二步：填写注册信息</h2>
<p>点击"注册"按钮后，系统会引导您进入注册页面。您需要提供以下信息：</p>
<ul>
<li><strong>手机号码：</strong>用于接收验证码和账号安全验证，请确保手机号码真实有效。</li>
<li><strong>验证码：</strong>点击"获取验证码"后，系统会向您的手机发送6位数字验证码，请在5分钟内完成输入。</li>
<li><strong>设置密码：</strong>密码长度应为8-20位，建议包含字母、数字和特殊字符的组合，以提高账号安全性。</li>
<li><strong>昵称设置：</strong>为自己取一个独特的昵称，这将显示在您的个人主页和评论区域。</li>
</ul>

<h2>第三步：完成实名认证</h2>
<p>根据相关规定，JM Comic要求用户完成实名认证后才能使用全部功能。您需要提供真实姓名和身份证号码进行验证。系统采用加密传输技术，确保您的个人信息安全。</p>
<p>认证通过后，您将获得完整的阅读权限，包括收藏、评论、订阅更新等功能。</p>

<h2>注册后的推荐操作</h2>
<ul>
<li>完善个人资料：上传头像、设置阅读偏好</li>
<li>关注喜爱的作者：第一时间获取更新通知</li>
<li>浏览分类推荐：根据您的喜好发现更多优质漫画</li>
<li>了解会员权益：升级会员享受无广告、高清画质等特权</li>
</ul>`,
    category: 'getting-started',
    categoryName: '入门指南',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20smartphone%20screen%20showing%20registration%20form%20interface%20with%20Japanese%20manga%20style%20illustration%20in%20background%2C%20warm%20lighting%2C%20clean%20UI%20design%2C%20soft%20gradient%20background%20with%20subtle%20comic%20elements%2C%20editorial%20photography&width=800&height=450&seq=article-register-01&orientation=landscape',
    author: 'JM Comic 官方',
    publishDate: '2026-08-10',
    readTime: '5分钟',
    tags: ['注册教程', '新手入门', '账号安全'],
    featured: true,
  },
  {
    slug: 'jm-comic-vip-benefits',
    title: 'JM Comic 会员权益全解析：普通会员 vs 高级会员',
    excerpt: '全面对比JM Comic普通会员与高级会员的各项权益差异，包括阅读权限、画质选择、离线下载、专属福利等，帮助您选择最适合的会员方案。',
    content: `<h2>会员等级概览</h2>
<p>JM Comic提供两种会员等级：<strong>普通会员</strong>（免费注册即可获得）和<strong>高级会员</strong>（付费订阅）。以下是两种会员的详细权益对比。</p>

<h2>普通会员权益</h2>
<ul>
<li>每日免费阅读10话漫画内容</li>
<li>标准清晰度画质（720P）</li>
<li>基础书签功能，最多保存50部作品</li>
<li>参与社区评论和互动</li>
<li>接收作品更新通知</li>
<li>每月3次离线下载额度</li>
</ul>

<h2>高级会员权益</h2>
<ul>
<li><strong>无限阅读：</strong>畅读平台全部漫画作品，无每日阅读限制</li>
<li><strong>超高清画质：</strong>支持1080P甚至4K超清画质，细节纤毫毕现</li>
<li><strong>无限书签：</strong>无上限保存喜爱的作品，随时随地继续阅读</li>
<li><strong>离线下载：</strong>每月100话离线下载额度，无网络也能畅享阅读</li>
<li><strong>去广告体验：</strong>纯净阅读界面，零广告干扰</li>
<li><strong>抢先阅读：</strong>热门作品可提前24小时阅读最新话</li>
<li><strong>专属徽章：</strong>高级会员专属身份标识，彰显尊贵身份</li>
<li><strong>优先客服：</strong>专属客服通道，问题优先处理</li>
</ul>

<h2>会员价格方案</h2>
<p>高级会员提供灵活的订阅方案：</p>
<ul>
<li>月度订阅：¥15/月</li>
<li>季度订阅：¥40/季（节省¥5）</li>
<li>年度订阅：¥128/年（节省¥52，相当于每月仅需¥10.7）</li>
</ul>
<p><strong>推荐选择年度订阅方案，性价比最高！</strong></p>`,
    category: 'membership',
    categoryName: '会员指南',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20golden%20membership%20card%20design%20with%20manga%20art%20style%20elements%2C%20premium%20VIP%20concept%2C%20warm%20golden%20and%20cream%20color%20palette%2C%20luxurious%20minimalist%20composition%20with%20soft%20lighting%2C%20Japanese%20comic%20illustration%20accents%20in%20background&width=800&height=450&seq=article-vip-02&orientation=landscape',
    author: 'JM Comic 官方',
    publishDate: '2026-08-08',
    readTime: '6分钟',
    tags: ['会员权益', 'VIP', '订阅方案'],
    featured: true,
  },
  {
    slug: 'jm-comic-category-navigation',
    title: 'JM Comic 分类导航详解：快速找到你喜欢的漫画类型',
    excerpt: '详细介绍JM Comic平台的漫画分类体系，包括少年漫画、少女漫画、同人漫画等八大分类，以及智能推荐系统的使用方法。',
    content: `<h2>JM Comic 分类体系</h2>
<p>JM Comic拥有完善的漫画分类体系，涵盖八大主流类型，每个分类下又细分多个子类别。以下为您详细介绍：</p>

<h2>少年漫画（Shonen）</h2>
<p>少年漫画是JM Comic最受欢迎的类别之一，主要面向青少年男性读者。代表作品涵盖热血战斗、运动竞技、冒险探索等题材。少年漫画通常以"友情、努力、胜利"为核心主题，故事情节紧凑、节奏明快。</p>

<h2>少女漫画（Shojo）</h2>
<p>少女漫画以细腻的情感描绘和唯美的画风著称，主要面向青少年女性读者。题材涵盖校园恋爱、奇幻浪漫、日常温馨等。JM Comic平台收录了大量经典和最新的少女漫画作品。</p>

<h2>同人漫画（Doujin）</h2>
<p>同人漫画板块是JM Comic最具活力的区域之一，汇集了大量由独立创作者制作的同人作品。这些作品基于热门动漫、游戏、小说等IP进行二次创作，展现出无限的创意和想象力。</p>

<h2>青年漫画（Seinen）</h2>
<p>面向成年读者的青年漫画，题材更加成熟多元，涵盖社会现实、科幻未来、历史战争、心理悬疑等深度内容。适合追求更有内涵故事的高阶读者。</p>

<h2>如何使用智能推荐</h2>
<p>JM Comic的智能推荐系统会根据您的阅读历史、收藏偏好和评分记录，为您精准推荐可能感兴趣的漫画作品。使用越频繁，推荐越准确。</p>`,
    category: 'getting-started',
    categoryName: '入门指南',
    coverImage: 'https://readdy.ai/api/search-image?query=Colorful%20organized%20grid%20of%20comic%20book%20categories%20displayed%20on%20a%20modern%20digital%20interface%2C%20manga%20style%20icons%20for%20each%20category%2C%20warm%20ambient%20lighting%2C%20clean%20minimalist%20UI%20design%2C%20Japanese%20aesthetic%20elements&width=800&height=450&seq=article-category-03&orientation=landscape',
    author: 'JM Comic 编辑团队',
    publishDate: '2026-08-05',
    readTime: '7分钟',
    tags: ['分类导航', '漫画类型', '智能推荐'],
    featured: true,
  },
  {
    slug: 'jm-comic-download-guide',
    title: 'JM Comic 漫画下载完整指南：离线阅读从未如此简单',
    excerpt: '手把手教你如何在JM Comic平台下载漫画进行离线阅读，包括下载步骤、存储管理、格式选择及常见下载问题的解决方案。',
    content: `<h2>下载功能概述</h2>
<p>JM Comic为高级会员提供强大的离线下载功能，让您在没有网络连接的情况下也能畅享漫画阅读。每月可下载100话内容，支持多种画质选择。</p>

<h2>下载步骤</h2>
<ol>
<li><strong>确认会员状态：</strong>确保您已开通高级会员，下载功能仅对高级会员开放。</li>
<li><strong>找到目标漫画：</strong>浏览或搜索您想要下载的漫画作品。</li>
<li><strong>选择章节：</strong>进入漫画详情页，选择要下载的具体章节。</li>
<li><strong>点击下载按钮：</strong>在章节页面找到下载图标（通常在右上角）。</li>
<li><strong>选择画质：</strong>根据您的存储空间和需求选择标清、高清或超清画质。</li>
<li><strong>等待完成：</strong>下载进度会显示在通知栏中，完成后即可离线阅读。</li>
</ol>

<h2>存储管理</h2>
<p>您可以在"我的下载"页面管理所有已下载的内容。建议定期清理已阅读的章节以释放存储空间。JM Comic支持设置自动清理策略，可在设置中进行配置。</p>

<h2>常见问题</h2>
<p><strong>Q: 下载的漫画可以永久保存吗？</strong></p>
<p>A: 下载内容在会员有效期内可随时阅读。会员过期后，已下载的内容将无法访问。</p>
<p><strong>Q: 下载速度慢怎么办？</strong></p>
<p>A: 建议在WiFi环境下进行下载，并避免同时下载过多章节。</p>`,
    category: 'getting-started',
    categoryName: '入门指南',
    coverImage: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20comic%20download%20interface%20with%20progress%20bar%2C%20manga%20art%20style%20wallpaper%20in%20background%2C%20cozy%20night%20scene%20with%20warm%20lamp%20light%2C%20modern%20digital%20reading%20concept%2C%20minimalist%20composition&width=800&height=450&seq=article-download-04&orientation=landscape',
    author: 'JM Comic 技术支持',
    publishDate: '2026-08-03',
    readTime: '5分钟',
    tags: ['离线下载', '下载教程', '存储管理'],
    featured: false,
  },
  {
    slug: 'jm-comic-reading-settings',
    title: 'JM Comic 阅读设置优化：打造专属的完美阅读体验',
    excerpt: '详细介绍JM Comic的各项阅读设置，包括翻页模式、亮度调节、字体大小、夜间模式等个性化功能，让阅读更加舒适。',
    content: `<h2>阅读模式选择</h2>
<p>JM Comic提供多种阅读模式，满足不同用户的阅读习惯：</p>
<ul>
<li><strong>纵向滚动模式：</strong>连续向下滚动阅读，适合快速浏览</li>
<li><strong>横向翻页模式：</strong>模拟纸质漫画翻页体验，左右滑动翻页</li>
<li><strong>自动播放模式：</strong>设定时间间隔后自动翻页，解放双手</li>
</ul>

<h2>显示设置</h2>
<p>您可以根据环境光线和个人偏好调整以下显示参数：</p>
<ul>
<li><strong>亮度调节：</strong>独立于系统亮度的阅读亮度设置</li>
<li><strong>夜间模式：</strong>深色背景配合柔和文字，保护夜间阅读的双眼</li>
<li><strong>护眼模式：</strong>减少蓝光输出，长时间阅读也不易疲劳</li>
<li><strong>字体大小：</strong>三段式字体大小调节，适应不同视力需求</li>
</ul>

<h2>高级功能</h2>
<ul>
<li><strong>双页显示：</strong>在平板设备上模拟翻开的纸质漫画效果</li>
<li><strong>缩放锁定：</strong>固定缩放比例，避免误触导致的缩放</li>
<li><strong>阅读进度云同步：</strong>在不同设备间同步阅读进度</li>
</ul>`,
    category: 'getting-started',
    categoryName: '入门指南',
    coverImage: 'https://readdy.ai/api/search-image?query=Digital%20tablet%20displaying%20manga%20reading%20interface%20with%20customizable%20settings%20panel%2C%20warm%20cozy%20reading%20nook%20setting%2C%20soft%20natural%20light%2C%20Japanese%20aesthetic%20decor%20elements%2C%20minimalist%20lifestyle%20photography&width=800&height=450&seq=article-reading-05&orientation=landscape',
    author: 'JM Comic 编辑团队',
    publishDate: '2026-07-30',
    readTime: '4分钟',
    tags: ['阅读设置', '个性化', '使用技巧'],
    featured: false,
  },
  {
    slug: 'jm-comic-community-guide',
    title: 'JM Comic 社区互动指南：评论、收藏与作者互动',
    excerpt: '全面介绍JM Comic平台的社区功能，包括如何参与评论讨论、管理收藏夹、关注作者动态以及参与平台活动获取奖励。',
    content: `<h2>社区功能概述</h2>
<p>JM Comic不仅是一个漫画阅读平台，更是一个充满活力的漫画爱好者社区。在这里，您可以与其他读者交流心得、分享推荐，甚至与喜爱的作者直接互动。</p>

<h2>评论与讨论</h2>
<p>每部漫画的每个章节都设有评论区，您可以：</p>
<ul>
<li>发表对剧情的看法和预测</li>
<li>给精彩的评论点赞</li>
<li>回复其他读者的评论，展开深入讨论</li>
<li>使用表情和贴纸丰富表达</li>
</ul>

<h2>收藏管理</h2>
<p>JM Comic提供完善的收藏管理功能：</p>
<ul>
<li>创建自定义收藏夹，按类型整理作品</li>
<li>为收藏的作品添加个人评分和标签</li>
<li>设置更新提醒，第一时间获取追更通知</li>
<li>导出收藏列表，方便分享给朋友</li>
</ul>

<h2>关注作者</h2>
<p>关注您喜爱的漫画家后，您将获得：</p>
<ul>
<li>新作发布的即时通知</li>
<li>作者动态和创作幕后分享</li>
<li>参与限定活动和粉丝福利的资格</li>
<li>与作者直接互动的机会</li>
</ul>`,
    category: 'community',
    categoryName: '社区攻略',
    coverImage: 'https://readdy.ai/api/search-image?query=Vibrant%20online%20community%20interface%20with%20comment%20sections%20and%20manga%20art%20elements%2C%20warm%20and%20inviting%20color%20scheme%2C%20modern%20social%20platform%20design%2C%20Japanese%20pop%20culture%20aesthetic%2C%20clean%20UI%20with%20soft%20shadows&width=800&height=450&seq=article-community-06&orientation=landscape',
    author: 'JM Comic 社区运营',
    publishDate: '2026-07-28',
    readTime: '6分钟',
    tags: ['社区互动', '评论', '收藏管理'],
    featured: false,
  },
  {
    slug: 'jm-comic-security-tips',
    title: 'JM Comic 账号安全指南：保护你的漫画收藏与个人信息',
    excerpt: '详细的安全设置教程，包括密码管理、二次验证、登录设备管理以及如何识别和防范诈骗信息，全方位保护您的账号安全。',
    content: `<h2>账号安全的重要性</h2>
<p>您的JM Comic账号不仅关联着个人阅读记录和收藏内容，还可能绑定了支付信息（高级会员）。保护好账号安全至关重要。</p>

<h2>基础安全设置</h2>
<ul>
<li><strong>强密码策略：</strong>使用至少12位包含大小写字母、数字和特殊字符的密码</li>
<li><strong>定期更换密码：</strong>建议每3个月更换一次密码</li>
<li><strong>绑定安全手机：</strong>确保绑定的手机号码始终可用</li>
<li><strong>绑定安全邮箱：</strong>设置备用邮箱用于密码找回</li>
</ul>

<h2>开启二次验证</h2>
<p>JM Comic支持多种二次验证方式：</p>
<ul>
<li>短信验证码</li>
<li>邮箱验证码</li>
<li>身份验证器应用（推荐）</li>
</ul>

<h2>防范诈骗提醒</h2>
<p>请注意以下常见诈骗手段：</p>
<ul>
<li>假冒官方客服索要密码或验证码</li>
<li>虚假的"免费会员"活动链接</li>
<li>非官方的第三方充值渠道</li>
<li>诱导分享账号的钓鱼网站</li>
</ul>
<p><strong>牢记：JM Comic官方永远不会通过私信或邮件索要您的密码！</strong></p>`,
    category: 'getting-started',
    categoryName: '入门指南',
    coverImage: 'https://readdy.ai/api/search-image?query=Digital%20security%20concept%20with%20shield%20icon%20and%20lock%20symbols%2C%20manga%20art%20style%20background%20elements%2C%20warm%20protective%20color%20palette%2C%20modern%20cybersecurity%20aesthetic%2C%20clean%20minimalist%20composition%20with%20soft%20lighting&width=800&height=450&seq=article-security-07&orientation=landscape',
    author: 'JM Comic 安全团队',
    publishDate: '2026-07-25',
    readTime: '5分钟',
    tags: ['账号安全', '安全设置', '防诈骗'],
    featured: false,
  },
  {
    slug: 'jm-comic-payment-guide',
    title: 'JM Comic 支付方式与充值教程：轻松开通高级会员',
    excerpt: '详细介绍JM Comic支持的各类支付方式，包括微信支付、支付宝、银联卡等，以及会员充值的完整操作流程和常见支付问题解答。',
    content: `<h2>支持的支付方式</h2>
<p>JM Comic为方便不同用户的需求，支持以下多种支付方式：</p>
<ul>
<li><strong>微信支付：</strong>扫码支付，方便快捷</li>
<li><strong>支付宝：</strong>支持余额、银行卡、花呗等多种付款方式</li>
<li><strong>银联卡：</strong>支持各大银行的借记卡和信用卡</li>
<li><strong>Apple Pay / Google Pay：</strong>iOS和Android用户的原生支付体验</li>
</ul>

<h2>充值流程</h2>
<ol>
<li>进入"我的"页面，点击"会员中心"</li>
<li>选择您想要的会员方案（月度/季度/年度）</li>
<li>确认订单信息，选择支付方式</li>
<li>完成支付验证</li>
<li>支付成功后，会员权益立即生效</li>
</ol>

<h2>常见支付问题</h2>
<p><strong>Q: 支付后会员未立即生效？</strong></p>
<p>A: 通常支付成功后1-5分钟内生效。如超过10分钟仍未生效，请联系客服并提供支付凭证。</p>
<p><strong>Q: 如何申请退款？</strong></p>
<p>A: 请在支付后7天内联系客服申请退款。已使用的会员权益按比例扣除相应费用。</p>`,
    category: 'membership',
    categoryName: '会员指南',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20mobile%20payment%20interface%20showing%20various%20payment%20options%20with%20manga%20style%20decorative%20elements%2C%20warm%20golden%20and%20cream%20tones%2C%20clean%20UI%20design%2C%20e-commerce%20concept%20with%20Japanese%20aesthetic%20touches&width=800&height=450&seq=article-payment-08&orientation=landscape',
    author: 'JM Comic 官方',
    publishDate: '2026-07-22',
    readTime: '4分钟',
    tags: ['支付方式', '充值教程', '会员开通'],
    featured: false,
  },
  {
    slug: 'jm-comic-app-guide',
    title: 'JM Comic App客户端安装与使用全攻略',
    excerpt: '覆盖iOS和Android双平台的App安装教程，包括官网下载、应用商店搜索、版本更新以及App与网页版的差异对比。',
    content: `<h2>App客户端优势</h2>
<p>JM Comic提供功能完善的移动端App，相比网页版具有以下优势：</p>
<ul>
<li>更流畅的阅读翻页体验</li>
<li>推送通知及时获取更新</li>
<li>离线下载功能更稳定</li>
<li>支持手势操作快捷控制</li>
<li>更省电的阅读模式</li>
</ul>

<h2>iOS安装教程</h2>
<ol>
<li>打开App Store，搜索"JM Comic"</li>
<li>认准官方开发者标识，点击"获取"</li>
<li>使用Face ID/Touch ID或Apple ID密码确认安装</li>
<li>安装完成后打开App，登录您的账号</li>
</ol>

<h2>Android安装教程</h2>
<ol>
<li>访问JM Comic官方网站下载APK安装包</li>
<li>或在各主流应用商店搜索"JM Comic"下载</li>
<li>安装前请确保已开启"允许安装未知来源应用"（仅官网APK）</li>
<li>安装完成后打开App并登录</li>
</ol>

<h2>版本更新</h2>
<p>JM Comic团队持续优化App体验，建议保持App为最新版本以获取最佳体验和新功能。iOS用户可在App Store开启自动更新，Android用户建议定期检查官网更新公告。</p>`,
    category: 'getting-started',
    categoryName: '入门指南',
    coverImage: 'https://readdy.ai/api/search-image?query=Smartphone%20displaying%20comic%20reading%20app%20interface%20on%20a%20clean%20desk%20with%20manga%20volumes%20nearby%2C%20warm%20natural%20light%2C%20cozy%20atmosphere%2C%20modern%20digital%20lifestyle%2C%20Japanese%20aesthetic%20elements&width=800&height=450&seq=article-app-09&orientation=landscape',
    author: 'JM Comic 产品团队',
    publishDate: '2026-07-20',
    readTime: '5分钟',
    tags: ['App下载', '客户端', '安装教程'],
    featured: false,
  },
  {
    slug: 'jm-comic-recommendation-algorithm',
    title: 'JM Comic 智能推荐算法揭秘：如何发现更多好漫画',
    excerpt: '深入了解JM Comic推荐系统的工作原理，学习如何优化您的阅读偏好设置，让推荐算法更精准地为您匹配喜爱的漫画作品。',
    content: `<h2>推荐系统概述</h2>
<p>JM Comic的智能推荐系统采用先进的协同过滤和深度学习算法，综合分析用户行为数据，为每位读者生成个性化的漫画推荐列表。</p>

<h2>影响推荐的因素</h2>
<ul>
<li><strong>阅读历史：</strong>您阅读过的作品类型和作者</li>
<li><strong>阅读时长：</strong>在每部作品上花费的时间</li>
<li><strong>收藏与评分：</strong>主动标记的偏好信号</li>
<li><strong>搜索关键词：</strong>反映您当前的兴趣方向</li>
<li><strong>相似用户：</strong>与您阅读偏好相近的用户的选择</li>
</ul>

<h2>优化推荐效果</h2>
<p>为了让推荐系统更好地为您服务，建议：</p>
<ul>
<li>积极为阅读过的作品评分</li>
<li>使用收藏功能标记喜爱的作品</li>
<li>完善个人阅读偏好设置</li>
<li>定期浏览"猜你喜欢"板块并给出反馈</li>
</ul>`,
    category: 'community',
    categoryName: '社区攻略',
    coverImage: 'https://readdy.ai/api/search-image?query=Abstract%20visualization%20of%20AI%20recommendation%20algorithm%20with%20manga%20style%20elements%2C%20warm%20color%20palette%2C%20flowing%20data%20lines%20connecting%20comic%20thumbnails%2C%20modern%20tech%20aesthetic%2C%20clean%20minimalist%20design&width=800&height=450&seq=article-algorithm-10&orientation=landscape',
    author: 'JM Comic 技术团队',
    publishDate: '2026-07-18',
    readTime: '5分钟',
    tags: ['推荐算法', '个性化', '发现漫画'],
    featured: false,
  },
];

export const featuredArticles = articles.filter((a) => a.featured);

export const getArticlesByCategory = (categorySlug: string) =>
  articles.filter((a) => a.category === categorySlug);

export const getArticleBySlug = (slug: string) =>
  articles.find((a) => a.slug === slug);

export const getRelatedArticles = (currentSlug: string, limit: number = 3) =>
  articles.filter((a) => a.slug !== currentSlug).slice(0, limit);